import { render, staticRenderFns } from "./BtnMaisDetalhes.vue?vue&type=template&id=fdb07458&"
import script from "./BtnMaisDetalhes.vue?vue&type=script&lang=js&"
export * from "./BtnMaisDetalhes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports